import React from "react";
import FilterToolbarForm from "../FilterToolbarForm";
import { mapStateToProps, mapDispatchToProps } from "./FilterToolbar.state";
import { connect } from "react-redux";

const FilterToolbar = ({ actions, forms }) => {
  const searchTermActions =
    actions.forms.filterToolbarForm.actions.fields.searchTerm;
  const searchTermField = forms.filterToolbarForm.fields.searchTerm;
  return <FilterToolbarForm field={searchTermField} actions={searchTermActions} />;
};

const ConnectedFilterToolbar = connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterToolbar);

export default ConnectedFilterToolbar;
